export const SaasMobileSecond = () => {
    return (
        <div className="pb-[20px]">
            <div className="flex  items-center justify-center mt-[23px]">
                <div className="text-[18px] font-bold text-[rgba(51,51,51,1)]">企业出海访问痛点</div>
            </div>
            <div className="mt-[28px] px-[6px]">
                <img src="/imgs/saas/mobile-4.png" className="w-full h-[142px] object-cover" />
            </div>
            <div className="mt-[28px]"></div>
            <div className="flex  items-center justify-center mt-[23px]">
                <div className="text-[18px] font-bold text-[rgba(51,51,51,1)]">全球应用加速原理</div>
            </div>
            <div className="mt-[7px] flex items-center justify-center">
                <div className="text-[8px] font-regular text-[rgba(37,61,93,1)] mr-[8px]">光年无界全球企业办公应用加速服务支持定制化需求合作</div>
                <div className="box-border w-[39.68px] h-[14.84px] flex flex-row justify-center items-center rounded-[3.2px] [box-shadow:0px_2.24px_4.480000019073486px_0px_rgba(0,0,0,0.1)]">
                    <div style={{
                        background: "linear-gradient(135deg, rgba(106, 181, 255, 1) 0%, rgba(183, 156, 255, 1) 100%)",
                        WebkitBackgroundClip: "text",
                        color: "transparent",
                        fontSize: "8px",
                        fontWeight: "700",
                    }}>立即咨询</div>
                </div>
            </div>
            <div className="px-[12px]">
                <img src="/imgs/saas/mobile-3.png" className="w-full h-[204px] mt-[13px] object-cover" />
            </div>
        </div>
    )
}